import { Grid } from '@mui/material'
import { useContext } from 'react'
import type { WordInfo } from '../interfaces/WordIf'
import { LanguageContext } from '../util/LanguageContext'
import { ItemButton } from './ItemButton'

type WordListProps = {
  items: WordInfo[]
  onDeleteWord: (text: string) => void
}
export const WordList: React.FC<WordListProps> = props => {
  // 文字列変換用
  const translation = useContext(LanguageContext)

  return (
    <>
      {props.items.map(word => (
        <Grid item lg={6} xl={3.7}>
          <ItemButton
            title={translation['label_emphasis_words']}
            id={word.id}
            text={word.text}
            onDel={props.onDeleteWord.bind(null, word.text)}
          />
        </Grid>
      ))}
    </>
  )
}
